import { useEffect, useRef } from 'react';

const stats = [
  { val: '15+', label: 'Yıllık Deneyim' },
  { val: '10K+', label: 'Mutlu Müşteri' },
  { val: '7/24', label: 'Acil Servis' },
  { val: '10', label: 'Marka Servisi' },
];

export default function HeroSection() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll('.anim');
    els?.forEach((el, i) => {
      setTimeout(() => {
        el.classList.add('opacity-100', 'translate-y-0');
        el.classList.remove('opacity-0', 'translate-y-6');
      }, i * 130);
    });
  }, []);

  return (
    <section id="hero" ref={ref} className="w-full pt-[70px] bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 pt-14 md:pt-20 pb-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* Left */}
          <div className="flex-1 min-w-0 pb-14 md:pb-20">
            <div className="anim opacity-0 translate-y-6 transition-all duration-500 mb-4">
              <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary bg-[#f0f7ff] border border-[#dbeafe] px-3 py-1.5 rounded-full">
                <i className="ri-map-pin-2-line" />
                Uzman Kombi Servisi
              </span>
            </div>

            <h1 className="anim opacity-0 translate-y-6 transition-all duration-500 text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 leading-[1.15] mb-5 tracking-tight">
              7/24 KOMBİ TEKNİK SERVİS<br />
              <span className="text-primary">ARIZA KAYIT BİRİMİ</span>
            </h1>

            <p className="anim opacity-0 translate-y-6 transition-all duration-500 text-base text-slate-500 leading-relaxed mb-8 max-w-md">
              Şu an açık kombi servisi. Hemen uzman personelimizi arayın, arıza randevusu oluşturun. 30 dakikada servis adresinizde.
            </p>

            {/* CTAs */}
            <div className="anim opacity-0 translate-y-6 transition-all duration-500 flex flex-col sm:flex-row gap-3 mb-8">
              <a
                href="tel:05332836679"
                className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-white font-bold text-base px-8 py-4 rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill" />
                SERVİS ÇAĞIR
              </a>
              <a
                href="https://wa.me/905332836679"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white border border-slate-200 hover:border-[#b3d9f8] text-slate-700 hover:text-primary font-semibold text-base px-8 py-4 rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-green-500 text-lg" />
                WhatsApp'tan Yaz
              </a>
            </div>

            {/* Mini trust tags */}
            <div className="anim opacity-0 translate-y-6 transition-all duration-500 flex flex-wrap gap-2 mb-10">
              {['Deneyimli kombi ustaları', 'Şeffaf fiyatlandırma', 'Orijinal yedek parça', '7/24 acil servis'].map((tag) => (
                <span key={tag} className="inline-flex items-center gap-1.5 text-xs text-slate-500 bg-[#f0f7ff] border border-[#dbeafe] px-3 py-1.5 rounded-full">
                  <i className="ri-checkbox-circle-line text-primary" />
                  {tag}
                </span>
              ))}
            </div>

            {/* Stats */}
            <div className="anim opacity-0 translate-y-6 transition-all duration-500 grid grid-cols-4 gap-4 pt-8 border-t border-slate-100">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-2xl md:text-3xl font-extrabold text-primary leading-none mb-1">{s.val}</p>
                  <p className="text-[11px] text-slate-400 font-medium leading-tight">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="anim opacity-0 translate-y-6 transition-all duration-500 flex-shrink-0 w-full lg:w-[460px]">
            <div className="relative w-full h-[360px] md:h-[480px] bg-[#f0f7ff] rounded-3xl overflow-hidden flex items-center justify-center">
              <img
                src="/images/hero-boiler-blue-v2.jpg"
                alt="Kombi Servisi"
                className="w-full h-full object-contain object-center p-6"
                loading="eager"
                fetchPriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}